import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DeviceAssignmentHistoryEffects } from './device-assignment-history.effects';
import { deviceAssignmentHistoryReducer } from './device-assignment-history.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('device-assignment-history', deviceAssignmentHistoryReducer),
    EffectsModule.forFeature([DeviceAssignmentHistoryEffects]),
  ],
  providers: [],
})
export class DeviceAssignmentHistoryStoreModule {}
